import React from "react";
import Icon from "../../../components/AppIcon";

const TakingsSummaryCard = ({
  title,
  amount,
  icon,
  iconColor,
  trend,
  trendValue,
}) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })?.format(value);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 transition-base hover-lift">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1 md:mb-2">
            {title}
          </p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground">
            {formatCurrency(amount)}
          </p>
        </div>
        <div
          className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon
            name={icon}
            size={20}
            color={iconColor}
            className="md:w-6 md:h-6 lg:w-7 lg:h-7"
          />
        </div>
      </div>

      {trend && (
        <div className="flex items-center gap-2">
          <Icon
            name={trend === "up" ? "TrendingUp" : "TrendingDown"}
            size={16}
            color={
              trend === "up" ? "var(--color-success)" : "var(--color-error)"
            }
            className="flex-shrink-0"
          />
          <span
            className="text-xs md:text-sm font-caption font-semibold"
            style={{
              color:
                trend === "up" ? "var(--color-success)" : "var(--color-error)",
            }}
          >
            {trendValue}
          </span>
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            vs yesterday
          </span>
        </div>
      )}
    </div>
  );
};

export default TakingsSummaryCard;
